<script></script>
<template>
  <!-- Rating Card -->
  <div class="card card-info-link card-sm">
    <div class="card-body">
      <!-- List Checked -->
      <strong>Excellent </strong>
      <span class="text-primary">
        <i class="fa-sharp fa-solid fa-star"></i
        ><i class="fa-sharp fa-solid fa-star"></i
        ><i class="fa-sharp fa-solid fa-star"></i
        ><i class="fa-sharp fa-solid fa-star"></i
        ><i class="fa-sharp fa-solid fa-star"></i>
      </span>
      <strong> 4.9 out of 5</strong>

      <!-- End List Checked -->
    </div>
  </div>
  <!-- End Card -->
</template>
